define('CoreChargeItem.Shopping', [
    'CoreChargeItem.View',
    'CoreChargeItem.Helper',
    'Cart.Item.Actions.View.CoreChargeItem',
    'Cart.Item.Summary.View.CoreChargeItem'
], function CoreChargeItemShopping(
    CoreChargeItemView,
    CoreChargeItemHelper
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var pdp = container.getComponent('PDP');
            var plp = container.getComponent('PLP');
            if(plp && pdp) {
                try {
                    plp.addChildViews(
                        plp.PLP_VIEW, {
                            'ItemDetails.Options': {
                                'CoreChargeItem.View': {
                                    childViewIndex: 11,
                                    childViewConstructor: function addNonProfitPrice() {
                                        return new CoreChargeItemView({
                                            container: container,
                                            source: 'PLP'
                                        });
                                    }
                                }
                            }
                        }
                    );
                    pdp.addChildViews(
                        pdp.PDP_FULL_VIEW, {
                            'Product.Options': {
                                'CoreChargeItem.View': {
                                    childViewIndex: 11,
                                    childViewConstructor: function addNonProfitPrice() {
                                        return new CoreChargeItemView({
                                            container: container,
                                            source: 'PDP'
                                        });
                                    }
                                }
                            }
                        }
                    );
                    pdp.addChildViews(
                        pdp.PDP_QUICK_VIEW, {
                            'Product.Options': {
                                'CoreChargeItem.View': {
                                    childViewIndex: 11,
                                    childViewConstructor: function addNonProfitPrice() {
                                        return new CoreChargeItemView({
                                            container: container,
                                            source: 'PDP'
                                        });
                                    }
                                }
                            }
                        }
                    );
                    // To disable the link in the cart detail page view
                    layout.addToViewContextDefinition('Cart.Lines.View', 'isNavigable', 'boolean', function disableNavigable(context) {
                        if (context.item && CoreChargeItemHelper.isCoreChargeFeeItem(context.item)) {
                            context.isNavigable = false;
                        }
                        return context.isNavigable;
                    });
                    // Disable quantity box in cart.
                    layout.addToViewContextDefinition('Cart.Item.Summary.View', 'disableQtyBox', 'boolean', function disableQuantity(context) {
                        context.disableQtyBox = false;
                        if (context.line && context.line.item && CoreChargeItemHelper.isCoreChargeFeeItem(context.line.item)) {
                            context.disableQtyBox = true;
                        }
                        return context.disableQtyBox;
                    });
                    // Do not show cart actions
                    layout.addToViewContextDefinition('Cart.Item.Actions.View', 'showActions', 'boolean', function hideActions(context) {
                        context.showActions = true;
                        if (context.item && CoreChargeItemHelper.isCoreChargeFeeItem(context.item)) {
                            context.showActions = false;
                        }
                        return context.showActions;
                    });
                    // Remove header mini cart item link
                    layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'linkAttributes', 'string', function hideLink(context) {
                        if (context.line && context.line.item && CoreChargeItemHelper.isCoreChargeFeeItem(context.line.item)) {
                            context.linkAttributes = '';
                        }
                        return context.linkAttributes;
                    });
                } catch (error) {
                    console.warn('Error in CoreChargeItem.Shopping', error)
                }
            }

        }
    };
});
